import React, {useEffect} from 'react';
import {Collapse} from 'reactstrap';
import {Link, useLocation} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {getLoggedInUser} from '../../helpers/fakebackend_helper';
import {toggleLeftmenu} from '../../store/layout/actions';
import {DEALER_FLAG_NON_TEXTILE, DEALER_FLAG_TEXTILE} from '../Dealer/DealerConst';

const Navbar = ({leftMenu, toggleLeftmenu, t}) => {
  const location = useLocation();
  const authUser = getLoggedInUser();

  useEffect(() => {
    const ul = document.getElementById('navigation');
    if (!ul) return;

    const allActive = ul.querySelectorAll('.active');
    allActive.forEach((el) => el.classList.remove('active'));

    const items = ul.getElementsByTagName('a');
    let matchingMenuItem = null;

    for (let i = 0; i < items.length; i++) {
      if (location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }

    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [location.pathname]);

  const activateParentDropdown = (item) => {
    if (!item) return;
    item.classList.add('active');

    let parent = item.parentElement;
    for (let i = 0; i < 6; i++) {
      if (!parent) break;
      parent.classList.add('active');
      parent = parent.parentElement;
    }
  };

  const renderMenuItem = (path, label, roles, icon) => {
    if (authUser.user && roles.includes(authUser.user.role)) {
      return (
        <li className="nav-item dropdown">
          <Link
            className="nav-link dropdown-toggle arrow-none"
            to={path}
            onClick={() => toggleLeftmenu(false)}
          >
            {icon && <i className={`${icon} mr-2`} />}
            {t(label)}
          </Link>
        </li>
      );
    }
    return null;
  };

  return (
    <div className="topnav">
      <div className="container-fluid">
        <nav className="navbar navbar-light navbar-expand-lg topnav-menu" id="navigation">
          <Collapse isOpen={leftMenu} className="navbar-collapse" id="topnav-menu-content">
            <ul className="navbar-nav">

              {renderMenuItem('/dashboard', 'Dashboard', ['manager', 'staff', 'sales', 'dealer', 'engineer'], 'bx bx-home-circle')}
              {renderMenuItem('/machines', 'Machines', ['manager', 'staff', 'sales', 'dealer', 'engineer'])}
              {renderMenuItem('/printers', 'Printer', ['manager', 'staff', 'sales', 'dealer', 'engineer'])}
              {renderMenuItem('/claims', 'Claims', ['manager', 'staff', 'sales', 'dealer', 'engineer'])}
              {renderMenuItem('/customers', 'Customers', ['manager', 'staff', 'sales', 'dealer', 'engineer'])}
              {renderMenuItem('/dealers', 'Dealers', ['manager', 'staff', 'sales'])}
              {renderMenuItem('/members', 'Members', ['manager', 'staff', 'sales'])}
              {renderMenuItem('/services', 'Maintenance Service', ['manager', 'staff', 'engineer'])}
              {renderMenuItem('/overtake-printer', 'Overtake Printer', ['engineer'])}
              {renderMenuItem('/overtakes', 'Overtakes', ['manager', 'staff'])}
              {renderMenuItem('/notifications', 'Notifications', ['manager'])}
              {renderMenuItem('/dispatch', 'Receipt of parts', ['dispatcher'], 'mdi mdi-truck')}

              {['test', 'bimh', 'bbo'].includes(process.env.REACT_APP_REALM) && authUser?.user.flags?.includes(DEALER_FLAG_NON_TEXTILE) &&
                <li className="nav-item d-lg-none">
                  <Link to={'/downloads/non-textile'}>
                    <button type="button" className="btn btn-sm header-item waves-effect waves-light d-flex align-items-center">
                      <i className="mdi mdi-cloud-download font-size-16" />
                      <span className="font-size-13 ml-2">Downloads Non-Textile</span>
                    </button>
                  </Link>
                </li>
              }

              {['test', 'bimh', 'bbo'].includes(process.env.REACT_APP_REALM) && authUser?.user.flags?.includes(DEALER_FLAG_TEXTILE) &&
                <li className="nav-item d-lg-none">
                  <Link to={'/downloads/textile'}>
                    <button type="button" className="btn btn-sm header-item waves-effect waves-light d-flex align-items-center">
                      <i className="mdi mdi-cloud-download font-size-16" />
                      <span className="font-size-13 ml-2">Downloads Textile</span>
                    </button>
                  </Link>
                </li>
              }

            </ul>
          </Collapse>
        </nav>
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => ({
  leftMenu: state.Layout.leftMenu,
});

export default connect(mapStatetoProps, {toggleLeftmenu})(withTranslation()(Navbar));
